import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaWallet,
  FaEnvelope,
  FaLock,
  FaSave,
  FaExclamationTriangle,
} from "react-icons/fa";
import { useAdmin } from "../context/AdminContext";
import Alert from "../components/Alert";

const AdminChangeWallet = () => {
      const { HandleChangeWallet,alert ,showAlert} = useAdmin();
    
  const [loading, setLoading] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    walletAddress: "",
    adminPassword: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !formData.email.trim() ||
      !formData.walletAddress.trim() ||
      !formData.adminPassword.trim()
    ) {
      alert("Please fill all fields.");
      return;
    }

    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);

     
      await HandleChangeWallet(formData);


    //   console.log(formData);

    //   alert("Wallet updated successfully.");

      setFormData({
        email: "",
        walletAddress: "",
        adminPassword: "",
      });

      setShowConfirm(false);
    } catch (err) {
      console.log(err);
      alert("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
        <Alert
            type={alert.type} 
            message={alert.message} 
            isOpen={alert.isOpen}
            onClose={() => showAlert({ isOpen: false, type: '', message: '' })}
          />
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto"
      >
        <div className="bg-white border border-slate-200 rounded-3xl shadow-lg overflow-hidden">

          {/* Header */}

          <div className="bg-gradient-to-r from-slate-900 to-slate-800 px-8 py-7">

            <div className="flex items-center gap-4">

              <div className="w-14 h-14 rounded-2xl bg-yellow-400 flex items-center justify-center">
                <FaWallet className="text-slate-900 text-2xl" />
              </div>

              <div>
                <h2 className="text-3xl font-black text-white">
                  Change User Wallet
                </h2>

                <p className="text-slate-300 mt-1">
                  Update any user's wallet address securely.
                </p>
              </div>

            </div>

          </div>

          {/* Form */}

          <form
            onSubmit={handleSubmit}
            className="p-8 space-y-7"
          >

            {/* Email */}

            <div>

              <label className="flex items-center gap-2 text-sm font-bold text-slate-700 mb-3 uppercase tracking-wider">
                <FaEnvelope />
                User Email
              </label>

              <input
                type="email"
                name="email"
                placeholder="Enter user email"
                value={formData.email}
                onChange={handleChange}
                className="w-full rounded-2xl border border-slate-300 px-5 py-4 outline-none focus:ring-2 focus:ring-yellow-400"
              />

            </div>

            {/* Wallet */}

            <div>

              <label className="flex items-center gap-2 text-sm font-bold text-slate-700 mb-3 uppercase tracking-wider">
                <FaWallet />
                New Wallet Address
              </label>

              <textarea
                rows={4}
                name="walletAddress"
                placeholder="Paste new wallet address..."
                value={formData.walletAddress}
                onChange={handleChange}
                className="w-full rounded-2xl border border-slate-300 px-5 py-4 resize-none outline-none focus:ring-2 focus:ring-yellow-400"
              />

            </div>

            {/* Password */}

            <div>

              <label className="flex items-center gap-2 text-sm font-bold text-slate-700 mb-3 uppercase tracking-wider">
                <FaLock />
                Admin Password
              </label>

              <input
                type="password"
                name="adminPassword"
                placeholder="Enter admin password"
                value={formData.adminPassword}
                onChange={handleChange}
                className="w-full rounded-2xl border border-slate-300 px-5 py-4 outline-none focus:ring-2 focus:ring-yellow-400"
              />

            </div>

            {/* Preview */}

            

            {/* Button */}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-yellow-400 hover:bg-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all rounded-2xl py-4 font-black text-slate-900 flex items-center justify-center gap-3"
            >
              <FaSave />

              {loading ? "Please Wait..." : "Update Wallet"}

            </button>

          </form>

        </div>
      </motion.div>

      {/* Confirmation Modal */}

      <AnimatePresence>

        {showConfirm && (

          <>
            <motion.div
              className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />

            <motion.div
              className="fixed inset-0 flex items-center justify-center p-4 z-50"
              initial={{ opacity: 0, scale: .9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: .9 }}
            >

              <div className="bg-white rounded-3xl max-w-md w-full shadow-2xl overflow-hidden">

                <div className="p-8 text-center">

                  <div className="w-20 h-20 mx-auto rounded-full bg-yellow-100 flex items-center justify-center mb-5">
                    <FaExclamationTriangle className="text-yellow-500 text-4xl" />
                  </div>

                  <h2 className="text-2xl font-black text-slate-900">
                    Confirm Wallet Update
                  </h2>

                  <p className="text-slate-500 mt-3 leading-relaxed">
                    This action will permanently replace the user's wallet address.
                    Please verify all information before continuing.
                  </p>

                  <div className="mt-6 bg-slate-100 rounded-2xl p-4 text-left">

                    <p className="text-sm">
                      <strong>Email</strong>
                    </p>

                    <p className="text-slate-600 break-all mb-4">
                      {formData.email}
                    </p>

                    <p className="text-sm">
                      <strong>Wallet Address</strong>
                    </p>

                    <p className="text-slate-600 break-all">
                      {formData.walletAddress}
                    </p>

                  </div>

                  <div className="grid grid-cols-2 gap-3 mt-8">

                    <button
                      disabled={loading}
                      onClick={() => setShowConfirm(false)}
                      className="py-3 rounded-xl bg-slate-200 hover:bg-slate-300 font-semibold"
                    >
                      Cancel
                    </button>

                    <button
                      disabled={loading}
                      onClick={handleConfirm}
                      className="py-3 rounded-xl bg-red-600 hover:bg-red-700 text-white font-bold disabled:opacity-50"
                    >
                      {loading ? "Updating..." : "Confirm"}
                    </button>

                  </div>

                </div>

              </div>

            </motion.div>

          </>

        )}

      </AnimatePresence>
    </>
  );
};

export default AdminChangeWallet;